import React from 'react';

interface TableSkeletonProps {
    cols: number;
    rows?: number;
    className?: string;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ cols, rows = 6, className = '' }) => {
    return (
        <>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr key={`skeleton-row-${rowIndex}`} className={`animate-pulse border-b border-slate-100 last:border-0 ${className}`}>
                    {Array.from({ length: cols }).map((_, colIndex) => {
                        // Varied widths for realistic shimmering
                        const widthClass = colIndex === 0 ? 'w-8 mx-auto' : colIndex % 3 === 1 ? 'w-3/4' : colIndex % 3 === 2 ? 'w-1/2' : 'w-2/3';
                        return (
                            <td key={`skeleton-col-${colIndex}`} className="px-4 py-4 whitespace-nowrap">
                                <div className={`h-4 bg-slate-100 rounded-md ${widthClass}`}></div>
                            </td>
                        );
                    })}
                </tr>
            ))}
        </>
    );
};

export default TableSkeleton;
